const config = {
  cacheDisabled: false,
  cacheType: "REMOTE",
  columns: [
    {
      title: '线索ID',
      dataIndex: 'id',
      width: 190,
      fixed: 'left',
      render: 'clueIdRender',
    },
    {
      title: '客户姓名',
      dataIndex: 'name',
      width: 200,
      render: 'nameRender'
    },
    {
      title: '客户电话',
      dataIndex: 'phone',
      width: 200,
      render: 'checkPhone',
    },
    {
      title: '拨打状态',
      dataIndex: 'totalCount',
      width: 180,
      render: 'callStatusRender',
    },

    {
      title: '楼盘名称',
      dataIndex: 'buildingName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '客户来源',
      dataIndex: 'channelName',
      width: 260,
      ellipsis: true,
    },
    {
      title: '公司',
      dataIndex: 'orgName',
      width: 180,
    },
    {
      title: '云客服',
      dataIndex: 'seat',
      width: 150,
    },
    {
      title: '最后跟进时间',
      dataIndex: 'lastFollowTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '状态',
      dataIndex: 'statusName',
      width: 100,
      render: 'stateRender',
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 205,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'nameLike',
      label: '客户姓名',
    },
    {
      name: 'phone',
      label: '客户电话',
      itemType: 'number',
      span: 120,
    },
    {
      name: 'id',
      label: '线索ID',
      formItemProps: {
        getValueFromEvent: (e: any) => e?.target?.value.replace(/\D.*/, ''),
      },
    },
  ],
  batchActions: [
    {
      label: '批量领取',
      type: 'primary',
      auth: 'CallCluePickFromOcean',
      events: ['onClick:onBatchGetClue']
    },
  ],
}

export default config

